import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {AppWithData} from './App';
import registerServiceWorker from './registerServiceWorker';

import { ApolloProvider } from 'react-apollo';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import {BrowserRouter} from "react-router-dom";

import 'materialize-css/dist/css/materialize.css'
import 'materialize-css/dist/js/materialize.js'


const link = new HttpLink({
    uri: '/graphql',
    credentials: 'include',
    // headers: {
    // 'X-CSRF-Token': "xyz",
    // token: 'supersecret'
    // }
});


const client = new ApolloClient({
    link: link,
    cache: new InMemoryCache()
});


ReactDOM.render(
    <ApolloProvider client={client}>
        <BrowserRouter>
            <AppWithData/>
        </BrowserRouter>
    </ApolloProvider>,
    document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js